import Button from "react-bootstrap/Button";
import './index.css'

interface ButtonComponentProps {
    titel?: string;
    isDisabled?: boolean;
    type?: any;
    onClick?: any;
    icon?: any;
    colour?: string;
    style?: React.CSSProperties; 
    fullWidth?: boolean;
}

//buttons that we frequently used
const ButtonComponent: React.FC<ButtonComponentProps> = ({ titel, isDisabled, type, onClick, icon, colour, fullWidth }) => {
    return (<>
        <Button className={`buttonColorButtonComponent mx-2 px-4 ${fullWidth ? 'w-100' : ''}`} disabled={isDisabled} type={type} onClick={onClick}>
            <div className="button-container-styles">
                {icon} &nbsp;
                {titel}
            </div>
        </Button>
    </>)
}

export default ButtonComponent;